module.exports = __webpack_public_path__ + "static/media/grid-view-selected.8049f9f4.svg";